import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';

import { PRIMARY_GREY } from 'constants/colours';
import BackArrowIcon from 'components/common/icons/BackArrowIcon';

const BlankButton = styled.button`
  border: none;
  background: none;
  display: flex;
  color: ${PRIMARY_GREY};
  span {
    margin-left: 8px;
  }
`;

const BackButton: FunctionComponent<
  React.PropsWithChildren<{
    arrowSize?: 'small' | 'medium' | 'large';
    to?: string;
    onClick?: () => void;
    children?: JSX.Element | string;
  }>
> = ({ arrowSize = 'medium', to, onClick, children }) => {
  const navigate = useNavigate();

  const navigateBack = (): void => {
    if (onClick) {
      onClick();
    } else if (!to) {
      navigate(-1);
    }
  };

  const renderButton = (): JSX.Element => (
    <BlankButton type="button" onClick={navigateBack}>
      <BackArrowIcon size={arrowSize} />
      {children && <span>{children}</span>}
    </BlankButton>
  );

  if (to) {
    return <Link to={to}>{renderButton()}</Link>;
  }

  return renderButton();
};

export default BackButton;
